if (process.env.NEXT_PUBLIC_WORDPRESS_URL === undefined) {
  throw new Error(`Missing client-side environment variables. All these must be defined: NEXT_PUBLIC_WORDPRESS_URL`)
}

export const NAMES = [
  'Integrity',
  'Jeremiah',
  'Erin',
  'Ed',
  'Grace',
  'Jess',
  'Donna',
  'Brian',
  'Jamal',
  'Drew',
  'Aaron',
  'Grace',
  'Mitchell',
  'Betsy',
  'Ember',
  'Brian',
  'Cathy',
  'Chris',
  'Kim H',
  'Danny',
  'Ed',
  'Marshall',
  'Gaby',
  'Matt',
  'Jenn',
  'Joe',
  'John',
  'Jonathan',
  'Jordan',
  'Julie',
  'Kim R',
  'Mike',
  'Laura',
  'Christine',
  'Lisa',
  'Mark',
  'Megan',
  'Alex',
  'Roy',
  'Trom'
]
